import { Helmet } from 'react-helmet-async';
import { useState, useEffect } from 'react';
import * as React from 'react';
// @mui
import { Stack, Typography, Grid, Button } from '@mui/material';
import CardMedia from '@mui/material/CardMedia';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';

import { getDatabase, ref as dbref, runTransaction, set, child, get, update, remove } from "firebase/database";
import { initializeApp } from "firebase/app";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const firebaseConfig = {
  apiKey: "AIzaSyDLVrlBPuai36n-i4F5HQVTjSMkVeGVBak",
  authDomain: "onetweb-e3d8e.firebaseapp.com",
  databaseURL: "https://onetweb-e3d8e-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "onetweb-e3d8e",
  storageBucket: "onetweb-e3d8e.firebasestorage.app",
  messagingSenderId: "60910494595",
  appId: "1:60910494595:web:2dc6bf320d67371af04cb6",
  measurementId: "G-0ZTHXZBNP9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


const rtdb = getDatabase(app);

// ----------------------------------------------------------------------

export default function HomePage() {

  const [row, setRow] = useState([]);
  const [title, setTitle] = useState('');
  const [subtitle, setSubTitle] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(true);
  const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('md'));

    const [c1title, setc1Title] = React.useState('');
    const [c1description, setc1Description] = React.useState('');
    const [imgphoto1, setimgphoto1] = React.useState(null);
    const [bgvideo, setbgvideo] = useState(null);

  useEffect(() => {

      get(child(dbref(rtdb), `service`)).then((snapshot) => {
        if (snapshot.exists()) {

          setTitle(snapshot.val().title)
          setSubTitle(snapshot.val().subtitle)
          setDescription(snapshot.val().description)
          setbgvideo(snapshot.val().bg_fullPath)

          setc1Title(snapshot.val().c1title)
          setc1Description(snapshot.val().c1description)
          setimgphoto1(snapshot.val().file1_fullPath)

          setLoading(false);

        } else {

          setTitle('')
          setSubTitle('')
          setDescription('')
          setbgvideo(null)

          setc1Title('')
          setc1Description('')
          setimgphoto1(null)

          setLoading(false);
          console.log("No data available");
        }

        const arr = [];
        get(child(dbref(rtdb), `services`)).then((snapshot2) => {
          if (snapshot2.exists()) {
  
            snapshot2.forEach((doc) => {
  
              arr.push({
                ...doc.val()
              });
            
              
            })
  
  
            setRow(arr);
            setLoading(false);
  
          } else {
  
            setRow([]);
            setLoading(false);
            console.log("No data available");
          }
        }).catch((error) => {
          console.error(error);
        }); 

      }).catch((error) => {
        console.error(error);
      }); 

   
  }, [])

  if(loading){
      return (
        <Grid style={{ width: "100%", display: "flex", alignItems: "center",  flexDirection: "column"  }}>
          <Grid style={{ width: "100%", marginTop: 60, maxWidth: 1200, display: "flex", padding: 25, height: "80vh",
          flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <Box sx={{ display: 'flex' }}>
              <CircularProgress color="inherit" />
            </Box>
          </Grid>
        </Grid>
      );
    }

  return (
    <>
      <Helmet>
        <title> Services | OneT | Leading DevSecOps Service Provider</title>
      </Helmet>

      <Grid style={{top: 0, width: '100%',
        display: "flex",justifyContent: "center", alignItems: "center",  flexDirection: "column"  }}>

{matches ? <Grid style={{ zIndex:-1, position: "fixed", top: 0,backgroundColor: '#1b0049', 
        width: "100%",
        display: "flex", justifyContent: "flex-end", flexDirection: "column"  }}>
            <video height={"100%"} className='videoTag' playsInline autoPlay loop muted>
                <source src={bgvideo} type='video/mp4' />
            </video>
          </Grid> : <Grid style={{ zIndex:-1, position: "fixed", top: 0,backgroundColor: '#1b0049', 
        
        height: "110vh",
        display: "flex", justifyContent: "flex-end", flexDirection: "column"  }}>
            <video height={"100%"} className='videoTag' playsInline autoPlay loop muted>
                <source src={bgvideo} type='video/mp4' />
            </video>
          </Grid>}
      

        <Grid style={{  maxWidth: 1200, zIndex:1, marginTop: 120, width: "100%", display: "flex", padding: 25,  paddingTop: 60, paddingBottom: 80,
            flexDirection: "column", justifyContent: "center", backgroundColor: "Transparent" }}>
            <Typography style={{ fontWeight: "bold", fontSize: 40, color: 'white', textTransform: "uppercase" }}>
            {title}
            </Typography>
            <Typography style={{marginTop: -10, fontWeight: "lighter", fontSize: 40, color: 'white', textTransform: "uppercase" }}>
            {subtitle}
            </Typography>
            <Typography sx={{ whiteSpace: "pre-wrap" }} style={{ maxWidth: 500, marginTop: 20, fontWeight: 300, fontSize: 16, color: 'white' }}>
            {description}
            </Typography>
        </Grid>

        

        <Grid style={{ zIndex:1, backgroundColor: '#1b0049', width: "100%", display: "flex",justifyContent: "center", alignItems: "center",  
          flexDirection: "column" }}>


          <Grid container spacing={2} style={{ padding: 25, maxWidth: 1200 }}>
            <Grid item sm={4} md={5} lg={5} xs={12} style={{ display:"flex", justifyContent: "center", alignItems:"flex-start", flexDirection: "column" }}>
              <Grid>
                <Typography style={{  fontWeight: "bold", fontSize: 24, color: 'white', textTransform: "uppercase", width:250 }}>
                {c1title}
                </Typography>
                <Typography style={{ fontSize: 16,  maxWidth: 200,color: "#af9ad3", marginTop: 20  }}>
                {c1description}
                </Typography>

              </Grid>
              

            </Grid>
            <Grid item sm={8} md={7} lg={7} xs={12} >
              <img src={imgphoto1} alt='service img' width={"100%"}/>
            </Grid>
          </Grid>


            <Grid style={{  padding: 25, maxWidth: 1200, marginTop: 10, width: "100%", display: "flex", alignItems: "center",
              flexDirection: "column",  backgroundColor: "Transparent" }}>
                <Typography style={{ textAlign: "center", fontWeight: "bold", fontSize: 36, color: 'white', textTransform: "uppercase" }}>
                OUR SERVICES
                </Typography>

            </Grid>

            <Grid container spacing={2} style={{ padding: 25, maxWidth: 1200 }}>

            {row.map(val=>{

              return <Grid item sm={6} md={4} lg={3} xs={12} style={{ cursor:'pointer', textDecoration: 'none',
                  }} ><Link href={`/services/${val.prefix}`} style={{  textDecoration: 'none' }} >
                <Grid style={{ display: "flex", flexDirection: "column", justifyContent: "center", borderRadius: 15, minHeight: 200,
                  backgroundColor: "#331a5c", textDecoration: 'none'
                }}>
                  <Grid>

                  <Typography style={{ textDecoration: 'none', lineHeight: 1.2, padding: 30,  fontWeight: "bold", fontSize: 22, paddingBottom: 5,
                        color: 'white' }}> 
                    {val.title}
                    </Typography>

                    <Grid style={{ display: "flex", padding: 30, flexDirection: "row" }}>
                    <Typography style={{ lineHeight: 1.2, width: 80, fontWeight: "bold", fontSize: 14,
                        color: 'white' }}>
                    Learn More
                    </Typography>
                    <img src='assets/solutions/arrowicon.png' alt='arrow icon' width={14}/>
                    </Grid>

                  </Grid>
                
                </Grid>
                </Link>
              </Grid>
            }) }
              
            </Grid>
        </Grid>
        
      </Grid>
    </>
  );
}
